import { TFunction } from "i18next";
import { DataGridHeading } from "@inductiveautomation/ws-components";

export const trainingBreadcrumb = (t: TFunction) => ({
  id: "training",
  label: t("training.title"),
  onClick: () => undefined,
});

export const credentialHeadings = (t: TFunction): DataGridHeading[] => [
  {
    id: "heading-certification",
    label: t("training.headings.credential"),
  },
  { id: "heading-earned", label: t("training.headings.earned") },
  { id: "heading-expires", label: "" },
  {
    id: "heading-status",
    label: t("training.headings.status"),
    alignment: "right" as const,
  },
];

export const certificationHeadings = (t: TFunction): DataGridHeading[] => [
  {
    id: "heading-certification",
    label: t("training.headings.certification"),
  },
  { id: "heading-earned", label: t("training.headings.earned") },
  { id: "heading-expires", label: t("training.headings.expires") },
  {
    id: "heading-status",
    label: t("training.headings.status"),
    alignment: "right" as const,
  },
];

export const courseHeadings = (t: TFunction): DataGridHeading[] => [
  { id: "heading-course", label: t("training.headings.course") },
  { id: "heading-completed", label: t("training.headings.completed") },
  {
    id: "heading-status",
    label: t("training.headings.status"),
    alignment: "right" as const,
  },
];
